import { useState } from "react";
import { loginAdmin } from "../api/tcg";
import AdminDashboard from "../components/adminDashboard.component";
import "./admin.page.css";

function AdminPage() {
    const [token, setToken] = useState<string | null>(null);
    const [isOwner, setIsOwner] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    async function handleLogin() {
        setLoading(true);
        setError(null);
        try {
            const result = await loginAdmin(username.trim(), password);
            setToken(result.token);
            setIsOwner(result.isOwner);
        } catch (err) {
            setError(err instanceof Error ? err.message : "Login fehlgeschlagen.");
        } finally {
            setLoading(false);
        }
    }

    function handleLogout() {
        setToken(null);
        setIsOwner(false);
        setUsername("");
        setPassword("");
    }

    if (token) {
        return (
            <div className="admin-page">
                <AdminDashboard token={token} isOwner={isOwner} onLogout={handleLogout} />
            </div>
        );
    }

    return (
        <div className="admin-page">
            <div className="admin-login-box">
                <h1>Admin Login</h1>

                <label className="admin-label" htmlFor="admin-username">Benutzername</label>
                <input
                    id="admin-username"
                    className="admin-input"
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    autoComplete="username"
                />

                <label className="admin-label" htmlFor="admin-password">Passwort</label>
                <input
                    id="admin-password"
                    className="admin-input"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    onKeyDown={(e) => { if (e.key === "Enter") handleLogin(); }}
                />

                {error && <p className="admin-error">{error}</p>}

                <button
                    className="admin-btn-primary"
                    onClick={handleLogin}
                    disabled={loading || !username.trim() || !password}
                >
                    {loading ? "Wird geprüft…" : "Einloggen"}
                </button>
            </div>
        </div>
    );
}

export default AdminPage;